import { Injectable } from '@angular/core';

const NGX_CM_TOKEN_IDENTIFIER = 'ngx-cm-token-identifier';

@Injectable()
export class NgxCmTokenService {

  constructor() { }

  getToken(): string {
    return localStorage.getItem(NGX_CM_TOKEN_IDENTIFIER);
  }

  setToken(token: string) {
    localStorage.setItem(NGX_CM_TOKEN_IDENTIFIER, token);
  }

  removeToken() {
    localStorage.removeItem(NGX_CM_TOKEN_IDENTIFIER);
  }
}
